import styles from './styles.css';
import { FC } from 'react';
import { Accordion, IAccordionItemProps, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IWhyNeedRealtorProps {
  title: string;
  firstAccordionColumn: IAccordionItemProps[];
  secondAccordionColumn: IAccordionItemProps[];
}

export const WhyNeedRealtor: FC<IWhyNeedRealtorProps> = ({ title, firstAccordionColumn, secondAccordionColumn }) => {
  const deviceType = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[deviceType])}>
      <div className={clsx(styles['title'], styles[deviceType])}>{title}</div>
      <div className={clsx(styles['accordions'], styles[deviceType])}>
        <Accordion items={firstAccordionColumn} />
        <Accordion items={secondAccordionColumn} />
      </div>
    </div>
  );
};
